import * as React from "react";

interface Props {
  size?: number;
  color?: string;
}

const PlayCircleIconV1 = ({ size = 18, color = "currentColor" }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="9" />
    <polygon points="10.5 8.5 16 12 10.5 15.5" />
  </svg>
);

export default PlayCircleIconV1;
